import { Languages } from 'lucide-react'

type TranslateButtonProps = {
    isTranslating: boolean
    onClick: (e: React.MouseEvent) => void
    disabled?: boolean
    isActive?: boolean
}

export const TranslateButton = ({ isTranslating, onClick, disabled, isActive = false }: TranslateButtonProps) => {
    return (
        <button
            onClick={onClick}
            className={`flex items-center justify-center p-0! w-5 h-5 rounded transition-colors disabled:opacity-50 ${isActive
                    ? 'bg-blue-500 hover:bg-blue-600'
                    : 'hover:bg-accent'
                }`}
            disabled={disabled || isTranslating}
            title="翻訳"
        >
            {isTranslating ? (
                <div className="w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin" />
            ) : (
                <Languages className={`w-4 h-4 ${isActive ? 'text-white' : 'text-blue-500'}`} />
            )}
        </button>
    )
}
